"use client";

import type { FC, Ref } from "react";
import {
  AnalysisListContent,
  type AnalysisListContentProps,
} from "@huub-web/shared";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface AnalysisListContentTemplateProps {
  templates?: TemplateCollection;
  observations?: AnalysisListContentProps["observations"];
}

/**
 * @deprecated
 */
export const AnalysisListContentTemplate: FC<
  AnalysisListContentTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, observations, ref }) => (
  <AnalysisListContent ref={ref} observations={observations}>
    {templates && <TemplatesParser templates={templates} level={1} />}
  </AnalysisListContent>
);
